
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viagens/[travelType]",
      function () {
        return require("private-next-pages/viagens/[travelType]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viagens/[travelType]"])
      });
    }
  